import { createAction } from '@ngrx/store';

export const notificationsOpen = createAction(
  '[Notification Window] Notification Open Window'
);

export const notificationsClose = createAction(
  '[Notification Window] Notification Close Window'
);
